import React from 'react';

import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import ActionsContainer from './ActionsContainer';

const ActionsLoader = () => {
	return (
		<ActionsContainer>
			<Skeleton
				variant="rounded"
				sx={(theme) => ({
					width: { xs: '100%', md: '79px' },
					height: theme.size.lg,
				})}
			/>
			<Skeleton
				variant="rounded"
				sx={(theme) => ({ width: theme.size.lg, height: theme.size.lg })}
			/>
		</ActionsContainer>
	);
};

export default ActionsLoader;
